/* tnf-notify-me.js — Open the MPS Notim "Notify me when available" modal
   from any card (Buy Again page, Wishlist page).

   v2 (2026-05-19): direct PDP redirect. Earlier versions attempted to fire the
   MPS Notim listing-mode handler in-place by synthesizing a transient
   .nm-btn-email element, but MPS only binds its delegated handler on real
   collection pages (`nmIsCollectionPage()` returned false on /pages/wishlist
   and /pages/buy-again), so the in-place click silently no-op'd most of the
   time. We now skip the brittle MPS dance entirely and just open the PDP in
   a new tab with `#tnf-notify-me` in the hash. The hash-handler IIFE in
   `assets/variant-bundle-common.js` (tnfNotifyMeHashOpen) polls for the
   on-page MPS Notify button and auto-clicks it on PDP load.

   USAGE
   -----
   Any clickable element with data-tnf-notify="1" plus:
       data-product-handle  (required for the fallback URL)
       data-product-url     (optional — falls back to /products/<handle>)
       data-variant-id      (optional — appended as ?variant=)
       data-product-id      (optional — used for GA4 attribution only)
       data-product-title   (optional — used for GA4 attribution only)

   DEBUG
   -----
   Set window.__tnfNotifyDebug = true in console, then click; logs everything.
*/
(function () {
  "use strict";
  if (window.__tnfNotifyMeWired) return;
  window.__tnfNotifyMeWired = true;

  function dbg() {
    if (!window.__tnfNotifyDebug) return;
    try { console.log.apply(console, ["[tnf-notify-me]"].concat([].slice.call(arguments))); } catch (e) {}
  }

  function openPdpWithHash(url, handle, variantId) {
    var base = url || ("/products/" + encodeURIComponent(handle || ""));
    var sep = base.indexOf("?") === -1 ? "?" : "&";
    var qs = variantId ? (sep + "variant=" + encodeURIComponent(variantId)) : "";
    var full = base + qs + "#tnf-notify-me";
    dbg("navigating to PDP (same window):", full);
    window.location.href = full;
  }

  function bindClicks(e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-tnf-notify="1"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var productId = btn.getAttribute("data-product-id") || "";
    var handle = btn.getAttribute("data-product-handle") || "";
    var url = btn.getAttribute("data-product-url") || "";
    var variantId = btn.getAttribute("data-variant-id") || "";

    dbg("click on data-tnf-notify button:", { productId: productId, handle: handle, url: url, variantId: variantId });

    // GA4 attribution — harmless if dataLayer absent.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "tnf_notify_me_click",
        product_id: productId,
        product_handle: handle,
        source: btn.getAttribute("data-tnf-notify-source") || "card"
      });
    } catch (err) {}

    openPdpWithHash(url, handle, variantId);
  }

  document.addEventListener("click", bindClicks, false);
  dbg("wired (v2 PDP-redirect, set window.__tnfNotifyDebug=true before clicking to see logs)");
})();

(function autoScrollOnNotifyHash() {
  // Capture the hash IMMEDIATELY at script load — variant-bundle-common.js's tnfNotifyMeHashOpen may strip the hash via history.replaceState before our window.load fires, killing our scroll. Capture once, retain.
  var SHOULD_SCROLL = window.location.hash === '#tnf-notify-me';
  if (!SHOULD_SCROLL) return;

  var attempts = 0;
  var SCROLL_SELECTORS = [
    '.nm-btn-out-of-stock',     // MPS Notim PDP out-of-stock container
    '.nm-btn-email',            // MPS Notim trigger button itself
    '.product-form__add-button', // fallback: regular add to cart button
    '[name="add"]',             // fallback: native add button
    '.product-form'             // last fallback: form itself
  ];

  function tryScroll(useSmooth) {
    attempts++;
    for (var i = 0; i < SCROLL_SELECTORS.length; i++) {
      var el = document.querySelector(SCROLL_SELECTORS[i]);
      if (el) {
        var rect = el.getBoundingClientRect();
        var targetY = window.pageYOffset + rect.top - 100; // 100px from top
        window.scrollTo({ top: targetY, behavior: useSmooth ? 'smooth' : 'auto' });
        return true;
      }
    }
    return false;
  }

  function pollScroll() {
    // First attempts use INSTANT scroll (no smooth) so the page jumps to the area BEFORE the MPS modal opens over it. Customer arrives at the right scroll position immediately.
    var useSmooth = attempts > 3;
    if (tryScroll(useSmooth)) {
      // After initial position, re-fire a smooth scroll at 600ms to fix any layout shift from late-loading images
      if (!useSmooth) setTimeout(function() { tryScroll(true); }, 600);
      return;
    }
    if (attempts < 50) setTimeout(pollScroll, 150); // up to 7.5s
  }

  // Start ASAP — don't wait for window.load (MPS modal opens before that on most browsers)
  if (document.readyState !== 'loading') {
    pollScroll();
  } else {
    document.addEventListener('DOMContentLoaded', pollScroll);
  }
})();
